// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, enableMultiTabIndexedDbPersistence } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; 
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyBJfdxS_e9E8Ww60YpYHf2GgdjnvLRRl5Q",
  // 🔥 ÇÖZÜM: Artık çirkin firebase linki değil, kendi esnaf tabelamız asılı!
  authDomain: "senabebe.com.tr",
  projectId: "sena-bebe-3b53e",
  storageBucket: "sena-bebe-3b53e.firebasestorage.app",
  messagingSenderId: "482040055297",
  appId: "1:482040055297:web:2b3ba2a0c7499bba392200",
  measurementId: "G-W68DFBEJDG",
};

// Uygulamayı başlat
const app = initializeApp(firebaseConfig);

// Bütün siteyi botlardan koruyan görünmez kalkan (App Check)
// 🔥 GÜNCELLEME: Burada appCheck değişkenini tanımlıyoruz ki dışarıya aktarabilelim
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6Ld7yi8tAAAAAC2g7-3iDycZ6h9IhdjSd0HichAT"),
  isTokenAutoRefreshEnabled: true 
});

// Veritabanı, Kimlik Doğrulama ve Depolama referanslarını oluştur
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Google sağlayıcısını projede kullanılmak üzere tanımladık
const googleProvider = new GoogleAuthProvider();

// Firebase Çevrimdışı Önbellek (Kota Koruyucu)
enableMultiTabIndexedDbPersistence(db).catch((err) => {
  if (err.code === "failed-precondition") {
    console.warn("Birden fazla sekme açık, önbellek sadece birinde aktif olabilir.");
  } else if (err.code === "unimplemented") {
    console.warn("Tarayıcı çevrimdışı önbellek özelliğini desteklemiyor.");
  }
});

// 🔥 GÜNCELLEME: appCheck'i diğer dosyalarda kullanabilmek için export listesine ekledik
export { db, auth, storage, googleProvider, appCheck };